// extracted by mini-css-extract-plugin
module.exports = {"search":"search-module--search--dTXlD","open":"search-module--open--15Jq1","results":"search-module--results--n5JJv","title":"search-module--title--3l6uo"};